import { useState, useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { getTopRankingSiniestros } from '../api/informesApi'

export const useTopRankingSiniestros = (trigger, reportData, contrato) => {
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!trigger || !contrato) return

    const controller = new AbortController()

    const fetchData = async () => {
      setIsLoading(true)
      setError(null)
      try {
        const response = await getTopRankingSiniestros(contrato, reportData?.fechaDesde, reportData?.fechaHasta, {
          signal: controller.signal,
        })
        setData(response.data)
      } catch (error) {
        if (error.name === 'CanceledError') return
        Sentry.captureException(error)
        setData([])
        setError(error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
    return () => controller.abort()
  }, [trigger, contrato, reportData?.fechaDesde, reportData?.fechaHasta])

  return { data, isLoading, error }
}
